import {
  Box,
  ComponentWithAs,
  Flex,
  FlexProps,
  IconProps,
  Text,
} from "@chakra-ui/react";

export interface StatItemProps extends FlexProps {
  icon?: ComponentWithAs<"svg", IconProps>;
  name: string;
  stat: string;
}

export const StatItem = (props: StatItemProps) => {
  const { icon, name, stat, ...rest } = props;

  return (
    <Flex
      alignItems="center"
      p="5px 10px"
      wrap="wrap"
      maxW="250px"
      color="inherit"
      gap="5px"
      {...rest}
    >
      {icon && <Box as={icon} />}
      <Text>{name}</Text>
      <Text fontWeight="bold">{stat}</Text>
    </Flex>
  );
};
